import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .subtitle {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 0 14px 0;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/user-account.css */
  a.link_reddit_account {
    background: linear-gradient(
      0deg,
      #b03000,
      #b43100,
      #b83200,
      #bb3300,
      #bf3400,
      #c33500,
      #c73600,
      #cb3700
    );
    padding: 10px 14px 11px 40px;
    color: #fff;
    position: relative;
    border-radius: 10px;
    font-size: 0.8rem;
  }
  a.link_reddit_account:hover {
    background: linear-gradient(
      0deg,
      #cb3700,
      #cb3700,
      #cb3700,
      #cb3700,
      #cb3700,
      #cb3700,
      #cb3700,
      #cb3700
    );
  }
  a.link_reddit_account:before {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    background: url(${icons.reddit_icon}) center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    content: '';
    z-index: 1;
  }
`

const developerCSS = css``

export const UserOverviewPanelCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
